import React from 'react';
import classNames from 'classnames';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import PageContent from 'src/Components/PageContent';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchCosmeticDetail, fetchMintConfig, fetchUserRanking } from 'src/redux/actions';
import { fetchCosmeticConfigs, fetchIngameBalance } from '@profile/src/redux/remoteActions';
import { AppError } from 'src/redux/types';
import ItemDetail from './ItemDetail';
import ItemDetailPlaceholder from './ItemDetailPlaceholder';
import styles from './styles.module.scss';
import ErrorView from 'src/Components/ErrorView';
import { ErrorViewType } from 'src/Components/ErrorView/config';
import { makeSelectCosmeticDetail } from './selectors';
import { navigateToMarketPlacePage } from 'src/utils/navigate';
import { MarketPlaceTab } from 'src/Pages/MarketplaceV2/Components/MarketTab/configs';
import BackButton from 'src/Components/BackButton';

const ItemDetailCard = ({
  className
}) => {
  const dispatch = useTypedDispatch();
  const history = useHistory();
  const params = useParams();
  const {
    state
  } = useLocation();
  const invalidated = useTypedSelector(state => state.cosmeticDetail.invalidated);
  const loading = useTypedSelector(state => state.cosmeticDetail.loading);
  const error = useTypedSelector(state => state.cosmeticDetail.error);
  const cosmetic = useTypedSelector(makeSelectCosmeticDetail());
  const {
    id: cosmeticId
  } = params;
  const refreshData = React.useCallback(() => {
    dispatch(fetchIngameBalance());
    dispatch(fetchCosmeticDetail(cosmeticId));
    dispatch(fetchCosmeticConfigs());
    dispatch(fetchUserRanking());
  }, [cosmeticId, dispatch]);
  React.useEffect(() => {
    refreshData();
    dispatch(fetchMintConfig());
  }, [refreshData, dispatch]);

  const renderLoading = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemDetail, styles.wrapBackButton)
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: styles.backButton,
    label: "Go back",
    onClick: onClickGoBack
  })), /*#__PURE__*/React.createElement(ItemDetailPlaceholder, null), ";");

  const renderContent = () => {
    return cosmetic ? /*#__PURE__*/React.createElement(ItemDetail, {
      onClickGoBack: onClickGoBack,
      className: styles.itemDetail,
      cosmeticDetail: cosmetic,
      refreshData: refreshData
    }) : null;
  };

  const renderError = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemDetail, styles.wrapBackButton)
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: styles.backButton,
    label: "Go back",
    onClick: onClickGoBack
  })), /*#__PURE__*/React.createElement(ErrorView, {
    className: styles.error,
    config: {
      type: ErrorViewType.Custom,
      content: 'Something went wrong. Reload this page or try again later',
      title: 'OOPS!'
    }
  }));

  const onClickGoBack = () => {
    if (state !== null && state !== void 0 && state.isFromInventory || state !== null && state !== void 0 && state.isFromHome) {
      history.goBack();
      return;
    }

    if (state !== null && state !== void 0 && state.isFromMarketplace) {
      navigateToMarketPlacePage({
        tab: MarketPlaceTab.COSMETICS
      });
      return;
    }

    navigateToMarketPlacePage({
      tab: MarketPlaceTab.HEROES
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidated,
    loading: loading,
    error: error !== AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  })));
};

export default ItemDetailCard;